import { Store } from '@ngrx/store';
import { IRegisterIkService } from './services/registerIk.service.interface';
import { Router } from '@angular/router';
import { Component, OnInit, Inject } from '@angular/core';
import { SessionModel } from '../../session/entities/sessionModel';
import { RegisterIkModel } from './entities/registerIkModel';
import { AppState } from '../../appState/appStateStore.module';
import { SessionService } from '../../session/session.service';
import { AbstractSessionService } from '../../session/abstract-session.service';
import { ErrorAction } from '../../appState/app.actions';
import { ERROR_SERVICE_NOT_AVAILABLE } from './../../error/errorMessage';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  model: RegisterIkModel = new RegisterIkModel();
  questionText: string = '... Aufgabe wird erstellt ...';
  message: string;
  registerDone = false;
  showEmailForm = false;
  confirmEmail = '';

  constructor(private router: Router
    , @Inject('IRegisterIkService') private registerIkService: IRegisterIkService
    , private sessionService: AbstractSessionService
    , private store: Store<AppState> ) { }

  ngOnInit() {
    this.setupQuestion();
 }

setupQuestion() {
  this.model.QuestionAnswer = '';
  this.model.QuestionToken = '';

  this.sessionService.getQuestion('Registration').subscribe(q => {
    this.questionText = q.QuestionText;
    this.model.QuestionToken = q.Token;
  });
}

  onSubmitIk() {
    this.registerIkService.checkUser(this.model)
    .then(result => this.showNextForm(result),
      reason => this.checkUserFailed(null, reason)
    )
    .catch(err => {
      this.registrationFailed(err);
    });
  }

  onSubmit() {
    if (this.model.Email === this.confirmEmail) {
      this.registerIkService.register(this.model)
        .then(result => this.ergebnisAuswerten(result),
          reason => this.registrationFailed(null, reason)
        )
        .catch(err => {
          this.registrationFailed(err);
        });
    } else {
      this.message = 'Die Werte der E-Mail und der bestätigung der E-Mail stimmen nicht überein.';
      this.confirmEmail = '';
    }
  }

  checkUserFailed(resultError, explicitMessage = null) {
    let errMessage = explicitMessage;
    if (resultError && resultError.error && resultError.error.Message) {
      errMessage = resultError.error.Message;
    } else if (resultError && resultError.message.indexOf('(unknown url)') >= 0) {
      this.store.dispatch( new ErrorAction( ERROR_SERVICE_NOT_AVAILABLE));
      this.router.navigate(['/error']);
    }

    this.message = 'Der Benutzername ist nicht gültig';

    this.setupQuestion();
  }

  registrationFailed(resultError, explicitMessage = null) {
    let errMessage = explicitMessage;
    if (resultError && resultError.error && resultError.error.Message) {
          errMessage = resultError.error.Message;
    } else if (resultError && resultError.message.indexOf('(unknown url)') >= 0) {
      this.store.dispatch( new ErrorAction( ERROR_SERVICE_NOT_AVAILABLE));
      this.router.navigate(['/error']);
    }

    this.message = 'Registrierung fehlgeschlagen!<br/>';

    this.setupQuestion();
}

  goBackToLogin() {
    this.router.navigate(['/login']);
  }

  ergebnisAuswerten(result: boolean) {
    if (result) {
      this.registerDone = true;
      this.message = 'Die Registrierung wurde erfolgreich abgeschlossen.\nSie bekommen die Zugangsdaten per E-Mail zugesandt.';
    } else {
      this.registrationFailed(null);
    }
  }

  showNextForm(result: boolean) {
    if (result) {
      this.showEmailForm = result;
      this.setupQuestion();
    } else {
      this.message = 'Der Benutzername ist nicht gültig';
      this.setupQuestion();
    }
  }

  clearMessage() {
    this.message = null;
    if (this.registerDone) {
      this.router.navigate(['/login']);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/account/register/register.component.ts